export const SERVICE_INSIGHT_ID = 'serviceInsightId';
export const FOCUS_SERVICE_INSIGHT = 'focusServiceInsight';
